import { Component, ojs, app, payload } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { clearSearchSuggestion, either } from "../../helpers";
import { $e } from "../../ojs.events";
import SearchSuggestions from "./SearchSuggestions";

const h = app("h");
const dc = app("dc");
const broker = app("broker");

ojs(SearchSuggestions);

export default class SearchBar extends Component {
    queryTimeout = null;
    autocompleteTimeout = null;

    constructor() {
        super();
        dc.searchPlaceholder.listener(this);
    }

    $$ojs = {
        routeChanged: () => {
            // A debounced suggestion request typed just before navigating
            // must not fire on the new page.
            clearTimeout(this.autocompleteTimeout);
        },
    };

    render(...args) {
        return h.div(
            {
                class: "search-bar-container w-100 position-relative",
            },
            // Mobile: Grouped (Button Hidden)
            h.div(
                {
                    class: "input-group rounded-pill overflow-hidden border border-2 shadow-sm d-flex d-md-none transition-all bg-white",
                },
                either(app("router").is("app.search"), {
                    class: "border-primary",
                }),
                h.span(
                    {
                        class: "input-group-text bg-transparent border-0 ps-3 text-muted",
                    },
                    h.i({ class: "bi bi-search" }),
                ),
                h.input(
                    {
                        type: "search",
                        class: "form-control border-0 px-2 bg-transparent shadow-none",
                        data_placeholder: dc.searchPlaceholder?.value,
                        placeholder: dc.searchPlaceholder?.value,
                        style: "height: 40px;",
                        hook: "mobile_search_input",
                        app_hook: "global-search-input",
                        value: dc.searchQuery.value ?? "",
                        listeners: {
                            click: (e) => {
                                let excluded = dc.searchHandlingRoutes ?? [];

                                let shouldRedirect = true;

                                for (let route of excluded) {
                                    if (app("router").is(route)) {
                                        shouldRedirect = false;
                                        break;
                                    }
                                }

                                if (shouldRedirect) {
                                    app("router").to("app.search");
                                }

                                broker.send($e.app.has.searchInputClick);
                            },
                            input: (e) => {
                                clearTimeout(this.autocompleteTimeout);

                                this.autocompleteTimeout = setTimeout(() => {
                                    broker.send(
                                        $e.app.has.searchCharacter,
                                        payload({ value: e.target.value }),
                                    );
                                }, 200);

                                clearTimeout(this.queryTimeout);

                                this.queryTimeout = setTimeout(() => {
                                    dc.searchQuery.value = e.target.value;

                                    broker.send(
                                        $e.app.has.searchQuery,
                                        payload({
                                            query: dc.searchQuery.value,
                                        }),
                                    );
                                }, 500);
                            },

                            blur: (e) => {
                                setTimeout(() => {
                                    clearSearchSuggestion();
                                }, 150);
                            },

                            keydown: (e) => {
                                if (e.key == "Enter") {
                                    dc.searchQuery.value = e.target.value;

                                    broker.send(
                                        $e.app.has.searchQuery,
                                        payload({
                                            query: dc.searchQuery.value,
                                        }),
                                    );
                                }
                            },
                        },
                    },
                    either(app("router").is("app.search"), {
                        autofocus: true,
                    }),
                ),
            ),

            // Desktop: Separate
            h.div(
                {
                    class: "d-none d-md-flex align-items-center gap-2",
                },
                h.div(
                    {
                        class: "input-group rounded-pill border shadow-sm overflow-hidden transition-all flex-grow-1",
                    },
                    either(app("router").is("app.search"), {
                        class: "border-primary border-2",
                    }),
                    h.span(
                        {
                            class: "input-group-text bg-transparent border-0 ps-3 text-muted",
                        },
                        h.i({ class: "bi bi-search" }),
                    ),
                    h.input(
                        {
                            type: "search",
                            class: "form-control border-0 px-2 bg-transparent shadow-none",
                            placeholder: dc.searchPlaceholder?.value,
                            style: "height: 40px;",
                            value: dc.searchQuery.value ?? "",
                            hook: "search_input",
                            app_hook: "global-search-input",
                            listeners: {
                                click: (e) => {
                                    let excluded =
                                        dc.searchHandlingRoutes ?? [];

                                    let shouldRedirect = true;

                                    for (let route of excluded) {
                                        if (app("router").is(route)) {
                                            shouldRedirect = false;
                                            break;
                                        }
                                    }

                                    if (shouldRedirect) {
                                        app("router").to("app.search");
                                    }

                                    broker.send($e.app.has.searchInputClick);
                                },
                                input: (e) => {
                                    clearTimeout(this.autocompleteTimeout);

                                    this.autocompleteTimeout = setTimeout(
                                        () => {
                                            broker.send(
                                                $e.app.has.searchCharacter,
                                                payload({
                                                    value: e.target.value,
                                                }),
                                            );
                                        },
                                        200,
                                    );

                                    clearTimeout(this.queryTimeout);

                                    this.queryTimeout = setTimeout(() => {
                                        dc.searchQuery.value = e.target.value;

                                        broker.send(
                                            $e.app.has.searchQuery,
                                            payload({
                                                query: dc.searchQuery.value,
                                            }),
                                        );
                                    }, 500);
                                },

                                blur: (e) => {
                                    setTimeout(() => {
                                        clearSearchSuggestion();
                                    }, 150);
                                },

                                keydown: (e) => {
                                    if (e.key == "Enter") {
                                        dc.searchQuery.value = e.target.value;

                                        broker.send(
                                            $e.app.has.searchQuery,
                                            payload({
                                                query: dc.searchQuery.value,
                                            }),
                                        );
                                    }
                                },
                            },
                        },

                        either(app("router").is("app.search"), {
                            autofocus: true,
                        }),
                    ),
                ),
                h.button(
                    {
                        class: "btn btn-primary rounded-pill px-4 fw-bold shadow-sm",
                        type: "button",
                        style: "height: 40px;",
                        hook: "desktop_search_button",
                        listeners: {
                            click: () => {
                                let excluded = dc.searchHandlingRoutes ?? [];

                                let shouldRedirect = true;

                                for (let route of excluded) {
                                    if (app("router").is(route)) {
                                        shouldRedirect = false;
                                        break;
                                    }
                                }

                                if (shouldRedirect) {
                                    app("router").to("app.search");
                                }
                            },
                        },
                    },
                    "Search",
                ),
            ),
            h.SearchSuggestions(),
            ...args,
        );
    }
}

ojs(SearchBar);
